export default "__VITE_ASSET__9bb9fJoc__"